import axios from 'axios';
import find from 'lodash/find.js';
import get from 'lodash/get.js';
import toCamelCase from '../utils/camelCase';
// import config from '../config';
import {
  API_ENDPOINT_CONFIGURATION,
  API_ENDPOINT_EDIT_CONFIGURATION,
  MPN_UNAVAILABLE,
  recordApiResponse,
  recordStormDoorAction,
} from '../utils/newRelic';

const OPTION_INTERNAL_NAME_PART_NUMBER = 'Manufacturer_Part_Number';
const CHOICE_INTERNAL_NAME_PART_NUMBER = 'Part_Number';

const isMPNActive = (options) => {
  const mpnOption = find(
    options,
    (option) => option.internalName === OPTION_INTERNAL_NAME_PART_NUMBER
  );
  return mpnOption && mpnOption.isActive;
};

const isMPNSet = (choices, selections) => {
  const mpnChoice = find(
    choices,
    (choice) => choice.internalName === CHOICE_INTERNAL_NAME_PART_NUMBER
  );
  const choiceId = get(mpnChoice, 'id', null);

  const mpnSelection = find(selections, { choiceId });
  return mpnSelection;
};

export const createConfigurationWithSkuPricing = (
  options,
  choices,
  selections,
  storeNum,
  mainImageUrl,
  sku,
  skuType,
  config
) => {
  const json = {
    siteId: config.siteId,
    productId: config.productId,
    selections: selections.map((selection) => ({
      optionId: selection.optionId,
      choiceValue: selection.choiceId,
      choiceName: selection.choiceValue,
      optionTags: selection.optionTags,
    })),
    storeNum,
    mainImageUrl,
    sku,
    skuType,
  };

  const url = `${config.customBaseUrl}/pipfigurator/api/v1/configurations`;
  const promise = axios.post(url, json);

  if (isMPNActive(options) && !isMPNSet(choices, selections)) {
    return recordStormDoorAction(MPN_UNAVAILABLE, 'MPN is unavailable', json);
  }
  return recordApiResponse(
    promise,
    API_ENDPOINT_CONFIGURATION,
    config.createConfigurationApi,
    json
  );
};

export const createConfiguration = (
  options,
  choices,
  selections,
  storeId,
  mainImageUrl,
  config
) => {
  const json = {
    siteId: config.siteId,
    productId: config.productId,
    selections: selections.map((selection) => ({
      optionId: selection.optionId,
      choiceValue: selection.choiceId,
      choiceName: selection.choiceValue,
      optionTags: selection.optionTags,
    })),
    storeId,
    mainImageUrl,
  };

  const url = `${config.configApiUrl}/api/configuration`;
  const promise = axios.post(url, json);

  if (isMPNActive(options) && !isMPNSet(choices, selections)) {
    return recordStormDoorAction(MPN_UNAVAILABLE, 'MPN is unavailable', json);
  }
  return recordApiResponse(
    promise,
    API_ENDPOINT_CONFIGURATION,
    config.createConfigurationApi,
    json
  );
};

export const editConfiguration = (options, choices, selections, config) => {
  const json = {
    siteId: config.siteId,
    productId: config.productId,
    selections,
  };

  const url = `${config.configApiUrl}/api/v1/Configuration/Edit/`;

  const promise = axios.post(url, json);

  return recordApiResponse(
    promise,
    API_ENDPOINT_EDIT_CONFIGURATION,
    config.editConfigurationApi,
    json
  );
};

export const createConfigurationForPpe = (
  selections,
  storeNum,
  retail,
  baseCost,
  costKey,
  unit,
  config,
  mainImageUrl = '',
  sku = '',
  skuType = ''
) => {
  const json = {
    siteId: config.siteId,
    productId: config.productId,
    selections: selections.map((selection) => ({
      optionId: selection.optionId,
      choiceValue: selection.choiceId,
      choiceName: typeof selection.choiceValue === 'string' ? selection.choiceValue : '0',
      optionTags: selection.optionTags,
    })),
    storeNum,
    basePrice: retail,
    baseCost,
    costKey,
    unit,
    mainImageUrl,
    sku,
    skuType,
  };

  // const url = 'http://custom.localtest.me/pipfigurator/api/v1/configurationsWithPrice';
  const url = `${config.customBaseUrl}/pipfigurator/api/v1/configurationsWithPrice`;

  return axios.post(url, json).then((response) => toCamelCase(response.data));

  // return recordApiResponse(promise, API_ENDPOINT_CONFIGURATION, config.createConfigurationApi, json);
};
